module.exports = { "default": require("core-js/library/fn/get-iterator"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/get-iterator.js
// module id = 338
// module chunks = 0